import { Props as AddToCartProps } from '$store/components/product/AddToCartButton.tsx'
import Button from '$store/components/ui/Button.tsx'
import Spinner from '$store/components/ui/Spinner.tsx'
import AddToCartButton from '$store/islands/AddToCartButton.tsx'
import { useUI } from '$store/sdk/useUI.ts'
import Icon from 'site/components/ui/Icon.tsx'
import { productSelectedSkuID } from 'site/components/product/ProductInfo.tsx'
import OutOfStock from 'site/components/product/OutOfStock.tsx'
import { Props as ProductDetailsProps } from 'site/components/product/ProductDetails.tsx'

interface Props extends AddToCartProps {
    isAvailable?: boolean
    texts: ProductDetailsProps['texts']
    categoryLink: string
}

//

function ProductDetailsAddToCart({ isAvailable, texts, categoryLink, ...addToCartProps }: Props) {
    const { selectingSku } = useUI()

    function scrollToSkuSelector() {
        const skuSelector = document.getElementById('sku-selector')

        if (skuSelector) {
            skuSelector.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
        }
    }

    if (!productSelectedSkuID.value) {
        return (
            <div class='flex flex-col gap-2 w-full z-20 max-w-[600px]'>
                <div class='dropdown dropdown-top lg:mt-0'>
                    <div tabindex={0} class='focus-within:mt-8 block transition-all peer'>
                        <Button
                            variant='addToCart'
                            data-deco='add-to-cart'
                            class='buy-button-product w-full h-[46px] !rounded-none lg:rounded-lg lg:h-9.5 text-base bottom-0 left-0 lg:relative z-20'
                            loading={selectingSku.value}
                            onClick={scrollToSkuSelector}
                        >
                            {selectingSku.value ? <Spinner size={24} /> : (
                                <div class='flex gap-x-2'>
                                    <Icon id='Bag' size={22} />
                                    Comprar
                                </div>
                            )}
                        </Button>
                    </div>
                    <div
                        id='variant'
                        tabindex={0}
                        class='!z-10 dropdown-content bg-[#fff6f6] border border-[#c21010] text-[#c21010] w-full py-1 text-center max-lg:!top-0 max-lg:!bottom-[initial] lg:!bottom-14 peer-focus-within:animate-alert'
                    >
                        Selecione um tamanho
                    </div>
                </div>
            </div>
        )
    }

    addToCartProps.itemsToAdd[0].skuId = productSelectedSkuID.value

    if (isAvailable) {
        return (
            <div class='flex gap-2 fixed bottom-0 left-0 lg:relative w-full max-w-[600px] z-20'>
                <AddToCartButton
                    {...addToCartProps}
                    loading={selectingSku.value}
                    variant='addToCart'
                >
                    <Icon id='Bag' size={22} />
                    Comprar
                </AddToCartButton>
            </div>
        )
    }

    // return <div></div>;

    return (
        <div class='mt-4'>
        <OutOfStock 
          productID={productSelectedSkuID.value} 
          texts={texts.outOfStockTexts} 
          categoryLink={categoryLink} 
        />
        </div>
    )
}

export default ProductDetailsAddToCart
